/* eslint-disable max-len */
import React from 'react';

export const WelcomeSVG = ({
  brandSecondary,
  brandPrimary,
  brandSecondaryBackground,
  brandTint,
  brandShade1,
  brandShade2,
  brandPrimaryBackground,
}: SVGThemeProps) => (
  <svg
    width={280}
    height={216}
    viewBox="0 0 280 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Welcome confirmation illustration"
  >
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.388 27.4054C166.62 23.1614 192.858 32.4894 227.566 59.9269C257.938 83.9354 266.643 120.76 261.703 143.46C256.89 165.579 242.383 184.597 221.936 189.88C201.769 195.09 182.31 188.725 152.179 162.206C122.047 135.687 97.617 133.358 79.6555 129.191C61.694 125.025 37.0445 111.527 40.2135 83.8374C43.383 56.1474 90.0935 30.0379 119.388 27.4054Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.25}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.667 198.722C163.202 184.634 177.594 163.643 171.641 126.823C166.214 93.2501 134.938 64.7526 87.0968 63.6861C39.1153 62.6161 11.4713 107.979 16.6103 126.803C21.7488 145.627 57.6798 128.956 64.3148 157.716C70.9498 186.477 72.7278 202.447 97.5928 207.238C117.898 211.149 135.063 204.927 143.667 198.722Z"
        fill={brandPrimary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.502404}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M233.051 164.876C206.267 191.66 145 184.305 115.61 154.915C86.2201 125.525 94.5936 79.9874 121.377 53.2029C148.162 26.4189 209.428 12.8029 238.818 42.1929C268.208 71.5829 259.835 138.093 233.051 164.876Z"
        fill={brandSecondaryBackground}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.502404}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.295 133.368C70.8673 133.368 40.2438 94.388 40.2438 60.9995C40.2438 27.6105 70.8673 6.5 101.295 6.5C131.723 6.5 174.259 33.5665 174.259 66.9555C174.259 100.344 131.723 133.368 101.295 133.368Z"
        fill={brandTint}
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.925 170.982H117.075C112.634 170.982 109 167.348 109 162.908V54.075C109 49.6335 112.634 46 117.075 46H165.925C170.367 46 174 49.6335 174 54.075V162.908C174 167.348 170.367 170.982 165.925 170.982Z"
      fill={brandShade2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.925 170.982H114.075C109.634 170.982 106 167.348 106 162.908V54.075C106 49.6335 109.634 46 114.075 46H162.925C167.367 46 171 49.6335 171 54.075V162.908C171 167.348 167.367 170.982 162.925 170.982Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M111.892 158.919C111.279 158.919 110.78 158.421 110.78 157.808V61.8244C110.78 61.2114 111.279 60.7129 111.892 60.7129H165.109C165.721 60.7129 166.22 61.2114 166.22 61.8244V157.808C166.22 158.421 165.721 158.919 165.109 158.919H111.892Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.247 55.6816H146.754C147.164 55.6816 147.5 55.3461 147.5 54.9356V54.4281C147.5 54.0176 147.164 53.6816 146.754 53.6816H133.247C132.836 53.6816 132.5 54.0176 132.5 54.4281V54.9356C132.5 55.3461 132.836 55.6816 133.247 55.6816Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.247 55.6816H130.754C131.164 55.6816 131.5 55.3461 131.5 54.9356V54.4281C131.5 54.0176 131.164 53.6816 130.754 53.6816H130.247C129.836 53.6816 129.5 54.0176 129.5 54.4281V54.9356C129.5 55.3461 129.836 55.6816 130.247 55.6816Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 146.88C162.5 147.98 161.6 148.88 160.5 148.88H116.5C115.4 148.88 114.5 147.98 114.5 146.88V140.88C114.5 139.78 115.4 138.88 116.5 138.88H160.5C161.6 138.88 162.5 139.78 162.5 140.88V146.88Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 145.88C162.5 146.98 161.6 147.88 160.5 147.88H116.5C115.4 147.88 114.5 146.98 114.5 145.88V139.88C114.5 138.78 115.4 137.88 116.5 137.88H160.5C161.6 137.88 162.5 138.78 162.5 139.88V145.88Z"
      fill={brandSecondaryBackground}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.5 142.88C122.5 144.536 121.157 145.88 119.5 145.88C117.844 145.88 116.5 144.536 116.5 142.88C116.5 141.223 117.844 139.88 119.5 139.88C121.157 139.88 122.5 141.223 122.5 142.88Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.144 144.328L117.608 142.793L118.145 142.255L119.144 143.254L120.145 142.253L120.202 142.198L120.855 141.546L121.392 142.083L119.648 143.826L119.592 143.88L119.144 144.328Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 131.88C162.5 132.98 161.6 133.88 160.5 133.88H116.5C115.4 133.88 114.5 132.98 114.5 131.88V125.88C114.5 124.78 115.4 123.88 116.5 123.88H160.5C161.6 123.88 162.5 124.78 162.5 125.88V131.88Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 130.88C162.5 131.98 161.6 132.88 160.5 132.88H116.5C115.4 132.88 114.5 131.98 114.5 130.88V124.88C114.5 123.78 115.4 122.88 116.5 122.88H160.5C161.6 122.88 162.5 123.78 162.5 124.88V130.88Z"
      fill={brandSecondaryBackground}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.5 127.88C122.5 129.536 121.157 130.88 119.5 130.88C117.844 130.88 116.5 129.536 116.5 127.88C116.5 126.223 117.844 124.88 119.5 124.88C121.157 124.88 122.5 126.223 122.5 127.88Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.144 129.328L117.608 127.793L118.145 127.255L119.144 128.254L120.145 127.253L120.202 127.198L120.855 126.546L121.392 127.083L119.648 128.826L119.592 128.88L119.144 129.328Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 116.88C162.5 117.98 161.6 118.88 160.5 118.88H116.5C115.4 118.88 114.5 117.98 114.5 116.88V110.88C114.5 109.78 115.4 108.88 116.5 108.88H160.5C161.6 108.88 162.5 109.78 162.5 110.88V116.88Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 115.88C162.5 116.98 161.6 117.88 160.5 117.88H116.5C115.4 117.88 114.5 116.98 114.5 115.88V109.88C114.5 108.78 115.4 107.88 116.5 107.88H160.5C161.6 107.88 162.5 108.78 162.5 109.88V115.88Z"
      fill={brandSecondaryBackground}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.5 112.88C122.5 114.536 121.157 115.88 119.5 115.88C117.844 115.88 116.5 114.536 116.5 112.88C116.5 111.223 117.844 109.88 119.5 109.88C121.157 109.88 122.5 111.223 122.5 112.88Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.144 114.328L117.608 112.793L118.145 112.255L119.144 113.254L120.145 112.253L120.202 112.198L120.855 111.546L121.392 112.083L119.648 113.826L119.592 113.88L119.144 114.328Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 101.88C162.5 102.98 161.6 103.88 160.5 103.88H116.5C115.4 103.88 114.5 102.98 114.5 101.88V95.8799C114.5 94.7799 115.4 93.8799 116.5 93.8799H160.5C161.6 93.8799 162.5 94.7799 162.5 95.8799V101.88Z"
      fill={brandTint}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.5 100.88C162.5 101.98 161.6 102.88 160.5 102.88H116.5C115.4 102.88 114.5 101.98 114.5 100.88V94.8799C114.5 93.7799 115.4 92.8799 116.5 92.8799H160.5C161.6 92.8799 162.5 93.7799 162.5 94.8799V100.88Z"
      fill={brandSecondaryBackground}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.5 97.8799C122.5 99.5364 121.157 100.88 119.5 100.88C117.844 100.88 116.5 99.5364 116.5 97.8799C116.5 96.2234 117.844 94.8799 119.5 94.8799C121.157 94.8799 122.5 96.2234 122.5 97.8799Z"
      fill={brandPrimary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.144 99.3284L117.608 97.7929L118.145 97.2554L119.144 98.2544L120.145 97.2529L120.202 97.1984L120.855 96.5459L121.392 97.0829L119.648 98.8264L119.592 98.8804L119.144 99.3284Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M144.523 80.627L132.33 85.9415C131.917 86.0625 131.571 85.9835 131.292 85.7045C131.013 85.4255 130.934 85.0795 131.056 84.6675L136.37 72.2915L144.523 80.627Z"
      fill="#ECD444"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M141.793 75.1308C142.934 76.2953 143.764 77.3878 144.287 78.4068C144.808 79.4258 144.899 80.1298 144.56 80.5173C144.147 80.8818 143.431 80.8033 142.412 80.2813C141.393 79.7598 140.307 78.9223 139.155 77.7693C138.002 76.6178 137.164 75.5313 136.643 74.5123C136.121 73.4928 136.03 72.7773 136.37 72.3643C136.782 72.0248 137.498 72.1098 138.517 72.6193C139.536 73.1288 140.629 73.9658 141.793 75.1308Z"
      fill="#877502"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M148.837 75.0395C148.727 74.9305 148.594 74.876 148.436 74.876C148.278 74.876 148.145 74.9305 148.036 75.0395C147.927 75.149 147.872 75.2825 147.872 75.44C147.872 75.598 147.927 75.7315 148.036 75.8405C148.145 75.9495 148.278 76.0045 148.436 76.0045C148.594 76.0045 148.727 75.9495 148.837 75.8405C148.946 75.7315 149 75.5915 149 75.422C149 75.2765 148.946 75.149 148.837 75.0395ZM145.597 83.1935C145.706 83.302 145.761 83.436 145.761 83.5935C145.761 83.751 145.706 83.8845 145.597 83.994C145.488 84.103 145.354 84.1575 145.197 84.1575C145.038 84.1575 144.906 84.103 144.796 83.994C144.687 83.8845 144.633 83.751 144.633 83.5935C144.633 83.436 144.687 83.302 144.796 83.1935C144.906 83.084 145.045 83.029 145.215 83.029C145.361 83.029 145.488 83.084 145.597 83.1935Z"
      fill="#ECD444"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M136.37 79.6077C136.345 79.8502 136.212 79.9717 135.969 79.9717C135.727 79.9717 135.605 79.8502 135.605 79.6077C135.605 79.3657 135.727 79.2432 135.969 79.2432C136.212 79.2432 136.345 79.3657 136.37 79.6077Z"
      fill="#73BE5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M143.686 70.5446C143.613 70.9091 143.419 71.1761 143.104 71.3456C142.861 71.4911 142.606 71.5636 142.339 71.5636L142.085 71.5276C141.866 71.5036 141.684 71.5276 141.538 71.6001C141.466 71.6491 141.417 71.7341 141.393 71.8551C141.368 71.9766 141.393 72.0616 141.466 72.1101C141.587 72.2316 141.744 72.3161 141.939 72.3646C142.351 72.4376 142.679 72.6011 142.922 72.8561C143.164 73.1111 143.261 73.4086 143.213 73.7476C143.164 74.0881 142.97 74.3546 142.631 74.5486C142.387 74.6701 142.133 74.7306 141.866 74.7306H141.612C141.417 74.6821 141.235 74.7066 141.065 74.8036C140.992 74.8276 140.938 74.9006 140.902 75.0216C140.865 75.1436 140.902 75.2526 141.01 75.3491C141.12 75.4466 141.284 75.5191 141.502 75.5676C141.72 75.6171 141.817 75.7496 141.793 75.9681C141.769 76.1866 141.648 76.3081 141.429 76.3321L141.357 76.2956C140.968 76.2471 140.653 76.0901 140.41 75.8226C140.167 75.5556 140.07 75.2526 140.119 74.9121C140.167 74.5731 140.356 74.3121 140.683 74.1301C141.01 73.9481 141.357 73.8816 141.72 73.9301C141.914 73.9786 142.085 73.9541 142.23 73.8571C142.327 73.8331 142.387 73.7656 142.412 73.6571C142.436 73.5476 142.4 73.4381 142.303 73.3291C142.206 73.2201 142.06 73.1536 141.866 73.1291H141.83C141.466 73.0561 141.156 72.8921 140.902 72.6376C140.647 72.3831 140.543 72.0796 140.592 71.7276C140.64 71.3761 140.822 71.1151 141.138 70.9451C141.453 70.7756 141.805 70.7146 142.194 70.7631C142.387 70.7876 142.558 70.7631 142.703 70.6901C142.8 70.6416 142.861 70.5571 142.885 70.4351C142.909 70.3141 142.885 70.2296 142.812 70.1806C142.691 70.0591 142.521 69.9746 142.303 69.9261C142.085 69.8776 141.993 69.7386 142.03 69.5071C142.066 69.2771 142.194 69.1611 142.412 69.1611C142.8 69.2346 143.122 69.3981 143.377 69.6531C143.632 69.9081 143.735 70.2051 143.686 70.5446Z"
      fill="#73BE5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M145.215 72.7285C144.996 72.7285 144.82 72.8015 144.687 72.947C144.554 73.0925 144.487 73.2685 144.487 73.4745C144.487 73.681 144.554 73.857 144.687 74.0025C144.82 74.148 144.996 74.2205 145.215 74.2205C145.433 74.2205 145.609 74.148 145.743 74.0025C145.876 73.857 145.943 73.681 145.943 73.4745C145.943 73.2685 145.876 73.0925 145.743 72.947C145.609 72.8015 145.433 72.7285 145.215 72.7285ZM148.054 78.916C148.224 78.916 148.357 78.843 148.454 78.6975C148.551 78.431 148.491 78.2245 148.272 78.079L147.945 77.897C147.411 77.5095 146.635 77.212 145.615 77.0055C144.596 76.7995 143.432 77.1815 142.121 78.152C141.903 78.322 141.885 78.516 142.066 78.7345C142.248 78.9525 142.449 78.989 142.667 78.843C143.735 78.043 144.681 77.7275 145.506 77.897C146.331 78.0675 146.998 78.334 147.508 78.6975L147.872 78.88C147.92 78.9045 147.981 78.916 148.054 78.916ZM138.554 82.119C138.335 82.119 138.159 82.1865 138.026 82.32C137.892 82.453 137.826 82.629 137.826 82.847C137.826 83.066 137.892 83.242 138.026 83.375C138.159 83.509 138.335 83.575 138.554 83.575C138.772 83.575 138.948 83.509 139.082 83.375C139.215 83.242 139.282 83.066 139.282 82.847C139.282 82.629 139.215 82.453 139.082 82.32C138.948 82.1865 138.772 82.119 138.554 82.119ZM133.677 73.4925C133.677 73.663 133.616 73.8085 133.495 73.9295C133.373 74.0515 133.222 74.112 133.039 74.112C132.857 74.112 132.705 74.0515 132.584 73.9295C132.463 73.8085 132.402 73.6565 132.402 73.4745C132.402 73.2925 132.463 73.141 132.584 73.0195C132.705 72.8985 132.857 72.8375 133.039 72.8375C133.222 72.8375 133.373 72.8985 133.495 73.0195C133.616 73.141 133.677 73.299 133.677 73.4925Z"
      fill="#F05B60"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M146.161 69.5981C145.918 69.5981 145.797 69.7196 145.797 69.9621C145.797 70.2051 145.918 70.3261 146.161 70.3261C146.403 70.3261 146.537 70.2051 146.562 69.9621C146.537 69.7196 146.403 69.5981 146.161 69.5981ZM138.226 73.4926C138.153 73.4926 138.092 73.4811 138.044 73.4566C137.826 73.3106 137.765 73.1166 137.862 72.8741L138.007 72.5831C138.153 72.3161 138.293 72.0366 138.426 71.7456C138.559 71.4546 138.627 71.1511 138.627 70.8361C138.675 70.0841 138.262 69.3796 137.389 68.7246C137.194 68.5551 137.176 68.3666 137.334 68.1601C137.492 67.9546 137.68 67.9236 137.899 68.0691C138.99 68.8701 139.524 69.7926 139.5 70.8361C139.476 71.2726 139.384 71.6726 139.227 72.0366C139.069 72.4006 138.918 72.7161 138.772 72.9836C138.699 73.0806 138.651 73.1776 138.627 73.2746C138.529 73.4201 138.396 73.4926 138.226 73.4926ZM132.73 68.4876C132.73 68.7186 132.608 68.8341 132.366 68.8341C132.123 68.8341 132.002 68.7186 132.002 68.4876C132.002 68.2576 132.123 68.1301 132.366 68.1061C132.608 68.1301 132.73 68.2576 132.73 68.4876Z"
      fill={brandSecondary}
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190 108.111C190 109.216 189.105 110.111 188 110.111C186.895 110.111 186 109.216 186 108.111C186 107.007 186.895 106.111 188 106.111C189.105 106.111 190 107.007 190 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208 108.111C208 109.768 206.656 111.111 205 111.111C203.344 111.111 202 109.768 202 108.111C202 106.455 203.344 105.111 205 105.111C206.656 105.111 208 106.455 208 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228 108.111C228 110.32 226.209 112.111 224 112.111C221.791 112.111 220 110.32 220 108.111C220 105.902 221.791 104.111 224 104.111C226.209 104.111 228 105.902 228 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M252 108.111C252 111.425 249.313 114.111 246 114.111C242.687 114.111 240 111.425 240 108.111C240 104.797 242.687 102.111 246 102.111C249.313 102.111 252 104.797 252 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M280 108.111C280 112.529 276.418 116.111 272 116.111C267.582 116.111 264 112.529 264 108.111C264 103.693 267.582 100.111 272 100.111C276.418 100.111 280 103.693 280 108.111Z"
        fill={brandSecondary}
      />
    </g>
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90 108.111C90 107.007 90.8955 106.111 92 106.111C93.1045 106.111 94 107.007 94 108.111C94 109.216 93.1045 110.111 92 110.111C90.8955 110.111 90 109.216 90 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72 108.111C72 106.455 73.3435 105.111 75 105.111C76.6565 105.111 78 106.455 78 108.111C78 109.768 76.6565 111.111 75 111.111C73.3435 111.111 72 109.768 72 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52 108.111C52 105.902 53.791 104.111 56 104.111C58.209 104.111 60 105.902 60 108.111C60 110.32 58.209 112.111 56 112.111C53.791 112.111 52 110.32 52 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 108.111C28 104.797 30.6865 102.111 34 102.111C37.3135 102.111 40 104.797 40 108.111C40 111.425 37.3135 114.111 34 114.111C30.6865 114.111 28 111.425 28 108.111Z"
        fill={brandSecondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 108.111C0 103.693 3.5815 100.111 8 100.111C12.4185 100.111 16 103.693 16 108.111C16 112.529 12.4185 116.111 8 116.111C3.5815 116.111 0 112.529 0 108.111Z"
        fill={brandSecondary}
      />
    </g>
  </svg>
);
